import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config';
import { LocalStorageKeys } from '../../../utils';

// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
    baseUrl: config.api_auth_base_url,
    prepareHeaders: (headers, { getState }) => {
        // By default, if we have a token in the store, let's use that for authenticated requests
        const token = localStorage.getItem(LocalStorageKeys.authToken);
        if (token) {
            headers.set("Authorization", "Bearer " + token);
            headers.set("x-build-code", config?.xbuildCode);
        }
      
        return headers;
    },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });

export const termsAndConditionAPI = createApi({
    reducerPath: "termsAndConditionAPI",
    baseQuery: baseQueryWithRetry,
    tagTypes: ['Auth'],
    endpoints: (builder) => ({
        getTermsCondition: builder.query({
            query: (payload) => ({ url: `client/terms_and_conditions`, method: "POST", body: { ...payload } }),
            transformResponse: (response, meta, arg) => {
                if (response?.status === 200) {
                    return response
                }
                return []
            },

        }),

    }),
})

// Export hooks for usage in functional components
export const { useLazyGetTermsConditionQuery } = termsAndConditionAPI
